type Tone = "success" | "warning" | "critical" | "info" | "neutral";

export function StatusBadge({ children, tone = "neutral" }: { children: React.ReactNode; tone?: Tone }) {
  return <span className={`wr-badge wr-badge--${tone}`}>{children}</span>;
}
